// utils/imageFallbacks.js
import ProductBg from "../assest/image/fallbacks/product.svg"
export const imageFallbacks = {
  product: ProductBg,
  user: "/images/fallbacks/user.png",
  banner: "/images/fallbacks/banner.png",
  avatar: "/images/fallbacks/avatar.png",
  category: "/images/fallbacks/category.png",
  default: "/images/fallbacks/no-image.png",
};
